import { memo } from 'react'
import type { DeliverySectionModelProps } from '@/components/home/components/delivery-section/delivery-section.model'
import { useDeliverySectionModel } from '@/components/home/components/delivery-section/delivery-section.model'
import { DeliverySectionView } from '@/components/home/components/delivery-section/delivery-section.view'

export const DeliverySectionViewModel = memo(function DeliverySectionViewModel(
  props: DeliverySectionModelProps,
) {
  const model = useDeliverySectionModel(props)
  return <DeliverySectionView {...model} />
})
